import * as React from 'react';
import { useHistory } from 'react-router';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import CustomForm from '../../components/form/CustomForm';

const AddUser = () => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/user`)
		.then(({ data = {} }) => {
			const { result = [] } = data;
			setFields(result);
		})
		.catch(err => {
			console.log(err);
		})
	}, []);

	const handleSubmit = values => {
		axios.post(`/api/user`, values)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/user');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/user')
	}

	return (
		<PageContent 
			background='#fff'
			subheader={{
				title: 'Системийн хэрэглэгч нэмэх',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
			/>
		</PageContent>
	)
}

export default AddUser;